export default __webpack_public_path__ + "static/media/wreckarmor1.4fd926da.png";